const style = {
  organizationProfilesTable__cell_action: {
    paddingLeft: '10px',
  },
  tableBody: {},
};

export default style;
